exports.defaultSettings = {
  navigationType: 'hover', // -- "hover" or "scroller" or "thumbsAndArrows",
  menuPosition: 'bottom',
  menuItemWidth: 'default',
  menuItemHeight: 'default',
}
